

import { useNavigate } from 'react-router-dom';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import useAppState from '../../context/AppContext';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import MgpGuarantyBar from '../../elements/MgpGuarantyBar/MgpGuarantyBar';
import { accessJsonAttr, getDayDifferent, isMobile } from '../../utils/utils';
import MgpFormSelect from '../../elements/MgpFormSelect/MgpFormSelect';
import { APP_URLS, ERROR_MESSAGES } from '../../const/AppConst';
import { useState } from 'react';
import { IGarantie, IInfoStep, IOffersDetails } from '../../context/model';
import MgpButton from '../../elements/MgpButton/MgpButton';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { displaySteps, formatFrAmount } from '../../utils/dataUtils';


type GuarantyCompareFormComponentProps = {
  handleSwitchPage: () => void;
  garanties: IGarantie[]
  options: Record<string, IOffersDetails | null>   
}

type  GuarantyCompareFormData = {
  offerCode: string
}


export default function GuarantyCompareFormComponent({handleSwitchPage, garanties, options}: Readonly<GuarantyCompareFormComponentProps>) {

  const navigate = useNavigate();

  const {
    state: { proposition, updatedProposition, infoSteps },
    dispatch,
  } = useAppState();

  const guarantyOptions = garanties.find(el => el.garantieBase)!.couvertures.map(example => {return example.couvertureTitre});

  const [option, setOption] = useState<string | null>(guarantyOptions[0]);

  const [hoveredElement, setHoveredElement] = useState<string>("");

  const validationSchema = Yup.object().shape({
    offerCode: Yup.string()
      .required(ERROR_MESSAGES.requiredMsg),
    });

  const {
    register,
    handleSubmit, setValue, getValues,
    formState: { errors },
  } = useForm<GuarantyCompareFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      offerCode : updatedProposition?.offerCode ? updatedProposition?.offerCode : "",
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = (data: GuarantyCompareFormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.offerCode = data.offerCode;
    }

    let steps = [...infoSteps] as IInfoStep[];
    const indexOfOldContractPage = steps.findIndex(el => el.path === APP_URLS.infoOldContractPage);

    if(!proposition?.configuration.hasPreviousInsuranceTermination || getDayDifferent(proposition?.effectiveDate) <= 32) {
      if(indexOfOldContractPage !== -1) {
        const index1 = steps.findIndex(step => step.path === APP_URLS.infoOldContractPage);
        steps.splice(index1, 1);

        dispatch({type: "UPDATE_STEPS", steps: steps})
      }

      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.recapPage, updatedProposition: tempUpdatedPropo});
      navigate({
        pathname: APP_URLS.recapPage,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      if (indexOfOldContractPage === -1) {
        dispatch({type: "UPDATE_STEPS", steps: displaySteps(proposition!)})
      }

      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoOldContractPage, updatedProposition: tempUpdatedPropo});
      navigate({
        pathname: APP_URLS.infoOldContractPage,
        search: `?id=${proposition!.propositionId}`,
      });
    }
    
  };

  const onPreviousAction = () => {
    handleSwitchPage();
  }

  const handleChooseDemande = (e: any, option: string) => { 
    e.preventDefault();
    setValue('offerCode' , option, {shouldValidate : true, });
  };

  const onMousseIn = (element: string) => {
    setHoveredElement(element);
  }

  const onMousseOut = () => {
    setHoveredElement("");
  }

  const chartColor = () => {
    const hoveredStyle = {
      scale: 1.05
    }
    return (
      <div className='m-y-sm'>
        <div className='color-note'>
          <p className='color-box bg-fushia' style={hoveredElement === "adherent" ? hoveredStyle : {}}></p>
          <p>Reste à charge</p>
        </div>
        <div className='color-note'>
          <p className='color-box bg-bleu' style={hoveredElement === "mgp" ? hoveredStyle : {}}></p>
          <p>Remboursement MGP</p>
        </div>
        <div className='color-note'>
          <p className='color-box bg-bleu-60' style={hoveredElement === "secu" ? hoveredStyle : {}}></p>
          <p>Remboursement Sécurité sociale</p>
        </div>
      </div>
    )
  }

  const getCouverture = (garantie: IGarantie) => {
    let title = option;
    if (!option) {
      const exampleOption = guarantyOptions && guarantyOptions.length > 0 ? guarantyOptions[0] : '';
      title = exampleOption;
    }
    return garantie.couvertures.find(el => el.couvertureTitre === title);
  }

 

 if (garanties.length === 0) {
    return <MgpMessage type="danger" message='Les garanties non trouvées' hasCloseBtn={true}/>;
  }

 
  if (isMobile()) {
    return (           
      <form  style={{width: '100%'}}>
        <div className='guaranty-container grid-flex va-center'>
          <div className='form-row'>
            <div className='form-group'>
              <MgpFormSelect id='option' labelFontWeight='regular'
                  data={guarantyOptions?.map(el => {return {code: el, label: el}}) || []}    
                  register={register}
                  errors={errors}
                  label='Remboursement de '
                  onChange={(e) => setOption(e.target.value)}
                  defaultValue={option??''}
              />
                 
            </div>
          </div>
        
          <div className='mb-xl'>
            <div className='flex' style={{height: "300px", gap: "10px"}}>
              {
                garanties.map((garantie, i) => 
                <div className='' key={i+1}>
                  <MgpGuarantyBar handleOnMousseIn={onMousseIn} handleOnMousseOut={onMousseOut} title={garantie.titre} value1={getCouverture(garantie)?.exemplePartSecu??0} value2={getCouverture(garantie)?.exemplePartMgp??0} value3={getCouverture(garantie)?.exemplePartAdherent??0} />
                </div>)
              }
            </div>
          </div>

          <div className='form-row mt-md'>
            <div className='form-group mw-100'>
              <p className='text fz-md fw-bold'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleTitre}</p>
              <p className='text mb-sm'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleDescription}</p> 
            </div>
          </div>
         

          <div className='form-row'>
            <div className='form-group mw-100'>
            {chartColor()}
            </div>
          </div>
          
          <div className=''>
            {
              garanties.map((garantie, i) =>  
                <div className={`select-btn m-y-md shadow-noir ${!getValues('offerCode') ? '' : getValues('offerCode') === garantie.code ? 'btn-selected' : 'un-select'}`} key={i+1}>
                  {
                    <div>
                      <p className='ta-center m-x-xs'>{garantie.titre}</p>
                      <p className='ml-lg'>{formatFrAmount(options[garantie.code]?.debitedAmountFromBankAccount!) ?? ''} / mois</p>
                    </div>
                  }
                  {
                    getValues('offerCode') === garantie.code ?
                    <MgpButton  type="button" text="" color='bleu' size="small" variant="inverse" icon="coche"/> :
                    <MgpButton  type="button" text="Choisir" color='bleu' size="small"  onClick={(e) => handleChooseDemande(e, garantie.code)}/>
                   
                  }
                </div>)
            }

          </div>
        </div>

        { garanties.length > 1 &&
          <div className='m-y-sm pb-sm' style={garanties.length > 2 ? {textAlign:'center'} : {}}>
              {errors && accessJsonAttr(errors, 'offerCode') && <p className="fushia m-y-md fw-medium fz-md">(*) Veuillez choisir une offre ci-dessus.</p>}
          </div>
        }
        
        <StickButtonsBloc disabledPreviousButton={false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
       
      </form>
  )
  }

    return (           
      <form  style={{width: '100%'}}>
        <div className='flex mb-lg'>
          {
            guarantyOptions?.map((el,i) => <p key={i+1} className={`guaranty-option fw-medium ${option === el ? "guaranty-option-selected" : ''}`} onClick={() => setOption(el)}>{el}</p>)
          }
        </div>
        
        <div className='guaranty-container va-center'>

          <div className='left-section col-width-2'>
            <p className='text fz-md fw-bold'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleTitre}</p>
            <p className='text mb-lg'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleDescription}</p> 
            
            { chartColor() }
          </div>
          
          <div className='main-section col-width-6 mb-lg'>
            <div className='flex ta-center' style={{height: "max-content", gap: "25px", flexWrap: 'nowrap'}}>
              {
                garanties.map((garantie, i) => 
                <div className='' key={i+1}>
                  <MgpGuarantyBar handleOnMousseIn={onMousseIn} handleOnMousseOut={onMousseOut} title={garantie.titre} value1={Number((getCouverture(garantie)?.exemplePartSecu??0).toFixed(2))} value2={getCouverture(garantie)?.exemplePartMgp??0} value3={getCouverture(garantie)?.exemplePartAdherent??0}  />
                </div>)
              }
            </div>
          </div>

          <div className='right-section col-width-4'>
            {
              garanties.map((garantie, i) =>  
                <div className={`select-btn m-y-md shadow-noir ${!getValues('offerCode') ? '' : getValues('offerCode') === garantie.code ? 'btn-selected' : 'un-select'}`} key={i+1}>
                  {
                    <div >
                      <p className='ta-center m-x-xs'>{garantie.titre}</p>
                      <p className='ml-lg'>{formatFrAmount(options[garantie.code]?.debitedAmountFromBankAccount!) ?? ''} / mois</p>
                    </div>
                  }
                  {
                    getValues('offerCode') === garantie.code ?
                    <MgpButton  type="button" text="Choisi" color='bleu' size="small" variant="inverse" icon="coche"/> :
                    <MgpButton  type="button" text="Choisir" color='bleu' size="small"  onClick={(e) => handleChooseDemande(e, garantie.code)}/>
                   
                  }
                 
                </div>)
            }

          </div>
        </div>

        { garanties.length > 1 &&
          <div className='m-y-sm pb-sm' style={garanties.length > 2 ? {textAlign:'center'} : {}}>
              {errors && accessJsonAttr(errors, 'offerCode') && <p className="fushia m-y-md fw-medium fz-md">(*) Veuillez choisir une offre ci-dessus.</p>}
          </div>
        }
        
        <StickButtonsBloc disabledPreviousButton={false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
       
      </form>
  )
}
